module.exports = __webpack_public_path__ + "assets/img/yj_icon.a770c0ae.png";